
import React from "react";

interface ProductsHeaderProps {
  title: string;
  subtitle: string;
  description: string;
}

const ProductsHeader: React.FC<ProductsHeaderProps> = ({ title, subtitle, description }) => {
  return (
    <header className="text-center mb-12">
      <h1 className="text-4xl font-bold tracking-tight mb-4">{title}</h1>
      <p className="text-lg text-gray-600 mb-8">{subtitle}</p>
      <p className="text-gray-600 max-w-2xl mx-auto mb-8">{description}</p>
    </header>
  );
};

export default ProductsHeader;
